import { ChevronDown, ChevronUp, ChevronsUpDown } from 'lucide-react';

// Shared sortable column header for the server-paged grids (Legacy Spark
// Chats, Discovery Calls). Sorting is server-side — a page only holds 50 of
// N rows, so reordering client-side would sort the window, not the grid.
// `sortKey` must be a key the matching handler's SORT_COLUMNS accepts.

export type SortDir = 'asc' | 'desc';

export interface SortState {
  key: string;
  dir: SortDir;
}

export default function SortableTh({
  label,
  sortKey,
  sort,
  onSort,
  className = '',
}: {
  label: string;
  sortKey: string;
  sort: SortState;
  onSort: (next: SortState) => void;
  className?: string;
}) {
  const active = sort.key === sortKey;
  const Icon = !active ? ChevronsUpDown : sort.dir === 'asc' ? ChevronUp : ChevronDown;

  return (
    <th
      scope="col"
      aria-sort={active ? (sort.dir === 'asc' ? 'ascending' : 'descending') : 'none'}
      className={`px-3 py-3 ${className}`}
    >
      <button
        type="button"
        // New column starts ascending; clicking the active one flips it.
        onClick={() => onSort({ key: sortKey, dir: active && sort.dir === 'asc' ? 'desc' : 'asc' })}
        className={[
          'group flex w-full items-center gap-1 whitespace-nowrap text-left',
          'uppercase tracking-wider transition',
          active ? 'text-brand-lime-700' : 'hover:text-brand-forest',
        ].join(' ')}
      >
        <span>{label}</span>
        <Icon
          aria-hidden="true"
          className={[
            'h-3.5 w-3.5 shrink-0 transition',
            // The inactive chevron stays faintly visible rather than
            // hover-only, so it's discoverable without hunting.
            active ? 'opacity-100' : 'opacity-30 group-hover:opacity-70',
          ].join(' ')}
        />
      </button>
    </th>
  );
}